// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../../node_modules/less-loader/dist/cjs.js!./base/CampaignBadge.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vxU8RNMbX8uE3qK2coI7 {
}
.vxU8RNMbX8uE3qK2coI7[data-variant="panel"] {
  right: -3px;
}
.vxU8RNMbX8uE3qK2coI7[data-variant="panel"][data-view="multi"] .h8Det5YjdBhaajT_njYw {
  width: 54px;
  height: 54px;
}
.h8Det5YjdBhaajT_njYw {
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .vxU8RNMbX8uE3qK2coI7[data-variant="panel"] {
    right: -4px;
  }
  .vxU8RNMbX8uE3qK2coI7[data-variant="panel"][data-view="multi"] .h8Det5YjdBhaajT_njYw {
    width: 40px;
    height: 40px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .vxU8RNMbX8uE3qK2coI7[data-variant="card"] {
    bottom: 90%;
    right: -35%;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .vxU8RNMbX8uE3qK2coI7[data-variant="card"] {
    bottom: 90%;
    right: -35%;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/CampaignBadge/css/MultiViewCampaignBadge.module.css"],"names":[],"mappings":"AAAA;AAEA;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;AAEA;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;AAAA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;AAAA;AAAA;AAAA","sourcesContent":[".wrapper {\n  composes: wrapper from './base/CampaignBadge.base.module.css';\n}\n.wrapper[data-variant=\"panel\"] {\n  right: -3px;\n}\n.wrapper[data-variant=\"panel\"][data-view=\"multi\"] .image {\n  width: 54px;\n  height: 54px;\n}\n.image {\n  composes: image from './base/CampaignBadge.base.module.css';\n}\n@media (--campaign-mobile) {\n  .wrapper[data-variant=\"panel\"] {\n    right: -4px;\n  }\n  .wrapper[data-variant=\"panel\"][data-view=\"multi\"] .image {\n    width: 40px;\n    height: 40px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .wrapper[data-variant=\"card\"] {\n    bottom: 90%;\n    right: -35%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `vxU8RNMbX8uE3qK2coI7 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["wrapper"]}`,
	"image": `h8Det5YjdBhaajT_njYw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["image"]}`
};
export default ___CSS_LOADER_EXPORT___;
